import React, { useContext, useEffect, useState } from "react";
import Row from "canvas-core-react/lib/Row";
import Column from "canvas-core-react/lib/Column";
import Margin from "canvas-core-react/lib/Margin";
import { ButtonOk } from "../buttonOk";
import Avatar from "canvas-core-react/lib/Avatar";
import { getInitialsUsername, getUsername, getValues } from "../../utils/utils";
import { CoachContext } from "../../context";
interface ConditionSystemProps {
  step: number;
  options: any;
  onClickParent: any;
}

export const ConditionSystem = ({ step, options, onClickParent }: ConditionSystemProps) => {

  const [disableBtn, setDisableBtn] = useState<any>(false);
  const [indexOut, setIndexOut] = useState(0);
  const { values } = useContext(CoachContext);

  useEffect(() => {
    const income = parseInt(getValues(values, "ingresos", "fijos").toString()) + parseInt(getValues(values, "ingresos", "variables").toString());
    const outcome = parseInt(getValues(values, "egresos", "indispensables").toString()) + parseInt(getValues(values, "egresos", "extra").toString());

    setIndexOut(income > outcome ? 0 : 1);
  }, []);

  const onTrigger = (event: any) => {
    setDisableBtn(true);
    onClickParent(event);

    const target = event.target.parentElement.parentElement as HTMLElement;
    let index = event.target.parentElement.getAttribute("data-index");

    let countElements =
      target.parentElement?.getElementsByTagName("button").length;

    let deletes = [];
    let x = 0;
    while (x < (countElements !== undefined ? countElements : 0)) {
      const value = target.parentElement
        ?.getElementsByTagName("button")
      [x].getAttribute("data-index");

      if (index !== value) {
        deletes.push(target.parentElement?.getElementsByTagName("button")[x]);
      }
      x++;
    }
    deletes.map((del: any) => {
      del.remove();
    });
  };
  return (
    <>
      <Row>
        <Column xs={2} sm={6} md={11} lg={11}>
          {options &&
            options.map((data: any, index: number) => {
              return (
                <Margin xs={18} sm={18} md={18} lg={18}>
                  <ButtonOk
                    title={data}
                    onClick={onTrigger}
                    index={indexOut}
                    step={step}
                    disabled={disableBtn}
                    isLarge={true}
                  />
                </Margin>
              );
            })}
        </Column>
        <Column xs={1} sm={1} md={1} lg={1}>
          <div style={{ display: !disableBtn ? "none" : "" }}>
            <Margin xs={18} sm={18} md={18} lg={18}><Avatar text={getInitialsUsername(getUsername(values, "nombreAlias"))}
              ariaLabel={getInitialsUsername(getUsername(values, "nombreAlias"))}
              size={42} />
            </Margin></div>

        </Column>
      </Row>
    </>
  );
};
